import Color from "color";
import isNumber from "lodash/isNumber";
import maxBy from "lodash/maxBy";
import { useThresholds } from "PFCore/hooks/queries/bookings/thresholds/use_thresholds";
import { useGetColor } from "PFCore/hooks/use_get_color";
import { useMemo } from "react";

import { DEFAULT_OVERBOOKING_COLOR } from "../../parts/helpers";
import { Overbooking } from "../../types";

type UseOverbookingColorProps = { overbookings: Pick<Overbooking, "utilization">[] };
type UseOverbookingColorReturn = {
  overbookingColor: Color<string>;
};

export const useOverbookingColor = ({
  overbookings
}: UseOverbookingColorProps): UseOverbookingColorReturn => {
  const thresholds = useThresholds(["overbooking"]);
  const getColor = useGetColor();

  const overbookingMaxLoad = useMemo(
    () => maxBy(overbookings || [], "utilization")?.utilization,
    [overbookings]
  );

  const overbookingColor = useMemo(() => {
    const backgroundColor: string | undefined =
      (isNumber(overbookingMaxLoad) &&
        thresholds?.overbooking?.find(
          (item) => overbookingMaxLoad * 100 >= item.min && overbookingMaxLoad * 100 <= item.max
        )?.color) ||
      undefined;

    return backgroundColor ? new Color(backgroundColor) : new Color(getColor(DEFAULT_OVERBOOKING_COLOR));
  }, [overbookingMaxLoad]);

  return { overbookingColor };
};
